// removed by extract-text-webpack-plugin
module.exports = {"fieldList":"FieldList__fieldList____oOxd","note":"FieldList__note___33vLy"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/Admin/FieldList/FieldList.scss
// module id = 735
// module chunks = 0